import Lenis from "lenis";

let lenis = null;
let rafId = null;

// Reasons the page should not scroll: the intro preloader, an open modal,
// the mobile menu, ...
let introActive = false;
let lockCount = 0;

const shouldLock = () => introActive || lockCount > 0;

const syncLock = () => {
  if (!lenis) return;
  if (shouldLock()) lenis.stop();
  else lenis.start();
};

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const initSmoothScroll = () => {
  if (lenis || typeof window === "undefined" || prefersReducedMotion()) {
    return lenis;
  }

  lenis = new Lenis({
    duration: 1.1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.5,
  });

  const raf = (time) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);

  syncLock();

  return lenis;
};

export const destroySmoothScroll = () => {
  if (rafId !== null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
  if (lenis) {
    lenis.destroy();
    lenis = null;
  }
};

export const getLenis = () => lenis;

/** Holds the page still while the intro preloader is on screen. */
export const setIntroActive = (active) => {
  introActive = Boolean(active);
  syncLock();
};

/** Reference-counted scroll lock for overlays (modal, mobile menu). */
export const lockScroll = () => {
  lockCount += 1;
  syncLock();
};

export const unlockScroll = () => {
  lockCount = Math.max(0, lockCount - 1);
  syncLock();
};

/**
 * Smoothly scrolls to a target (element, selector, number or "top"/"bottom").
 * Returns false when Lenis is not active (e.g. reduced motion), so callers
 * can fall back to the native APIs.
 */
export const scrollTo = (target, options = {}) => {
  if (!lenis) return false;
  lenis.scrollTo(target, options);
  return true;
};

export const scrollToTop = (immediate = true) => {
  if (scrollTo(0, { immediate })) return;

  window.scrollTo(0, 0);
  if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const container = document.getElementById("scroll-container");
  if (container) container.scrollTop = 0;
};
